// Places the walkers and the people who sit and stand around the city.
import { PI } from '../lib/math.js';
import { pick, rnd, rr } from '../lib/random.js';
import { scene } from '../core/scene.js';
import { octPts } from '../lib/shapes.js';
import { benches, blocks } from '../world/eixample.js';
import { BENCH } from '../world/park.js';
import { makeDog, makePerson, walkers } from './models.js';

export let sitSpots, standSpots, sups, beachLie, swimSpots, waders, volley;

export function buildCrowd() {
  for (let i = 0; i < 80; i++) {
    const b = pick(blocks),
      path = octPts(23.5, 4.44).map(([px, py]) => [b.cx + px, b.cz - py]),
      lens = [];
    let total = 0;
    for (let k = 0; k < 8; k++) {
      const [ax, az] = path[k],
        [bx, bz] = path[(k + 1) % 8];
      lens.push(Math.hypot(bx - ax, bz - az));
      total += lens[k];
    }
    const { g, legs } = makePerson(false);
    scene.add(g);
    walkers.push({
      g,
      legs,
      path,
      lens,
      total,
      b,
      s: rr(0, total),
      v: rr(0.5, 0.78) * (rnd() < 0.5 ? 1 : -1),
      ph: rr(0, 6),
      lat: 0,
      vv: 0,
      dist: 0,
      dog: rnd() < 0.12 ? makeDog() : null,
    });
  }
  // only the torso of a walker casts a shadow: limbs would add draw calls for no visible gain
  for (const w of walkers)
    w.g.traverse((o) => {
      if (o.isMesh && o !== w.g.children[0]) o.castShadow = false;
    });
  // people sitting on benches and waiting at the bus shelters
  // the characters themselves arrive with the GLB loader (sitSpots: hip height; standSpots: feet height)
  sitSpots = [];
  standSpots = [];
  sups = [];
  // beach people, filled in by the beach block and posed once the character models load
  beachLie = [];
  swimSpots = [];
  waders = [];
  volley = [];
  benches.forEach((bn) => {
    if (rnd() > 0.4) return;
    sitSpots.push({ x: bn.x, y: 0.35 + 0.49 * BENCH - 0.04, z: bn.z, ry: bn.ry });
  });
  for (const [x, z, ry] of [
    [-24.6, 47.9, PI],
    [-23.2, 48.1, PI + 0.3],
    [21.5, -47.9, 0],
    [47.9, 8.6, -PI / 2],
  ])
    standSpots.push({ x, y: 0.36, z, ry: ry + PI, parent: scene });
}
